export default __webpack_public_path__ + "static/media/colon.351abade.svg";